import React, { useMemo } from 'react';
import { columnDefs } from '../columnDefs';
import { useAppSelector } from 'hooks/useAppSelector';
import {
  getSelectedMember,
  getSelectedMemberId,
} from 'reducers/membersReducer';
import { INVESTMENT_ADVISOR_MEMBER } from 'constants/memberTypes';
import Member from 'ts/models/Member.model';
import { ColDef } from 'ag-grid-community';
import BalanceGridRow from '../types';

const OWNER_TYPE = 'Owner';
const AUTHORIZED_TYPE = 'Authorized';
const useColDefs = () => {
  const selectedMemberId = useAppSelector(getSelectedMemberId);
  const selectedMember: Member = useAppSelector(getSelectedMember);
  const isIRA = useMemo(() => {
    return selectedMember?.type === INVESTMENT_ADVISOR_MEMBER.type;
  }, [selectedMember.type]);

  const IRAColDef: ColDef<BalanceGridRow> = useMemo(
    () => ({
      headerName: 'Access Type',
      colId: 'authorized',
      width: 180,
      cellRenderer: ({ data }: { data: BalanceGridRow }) => {
        const accessType =
          data?.memberId === selectedMemberId ? OWNER_TYPE : AUTHORIZED_TYPE;
        return <div style={{ textAlign: 'center' }}>{accessType}</div>;
      },
    }),
    [selectedMemberId],
  );

  const colDefs = useMemo(() => {
    if (isIRA) {
      columnDefs.unshift(IRAColDef);
    }
    return columnDefs;
  }, [isIRA, IRAColDef]);
  return colDefs;
};

export default useColDefs;
